import { Flex, Image } from "@chakra-ui/react"
import React from "react"

interface Props {}

const CloudImageBrowserImageBroken: React.FC<Props> = () => {
  return (
    <Flex
      height="165px"
      alignItems="center"
      justifyContent="center"
      cursor="not-allowed"
      borderRadius={8}
      backgroundColor="blackAlpha.100"
    >
      <Image
        height="100px"
        src="images/cloud-providers/common/ic-img-failed-01.svg"
      />
    </Flex>
  )
}

export default CloudImageBrowserImageBroken
